

export const globalJson = {
  prod_company_id: 1110,
  dev_company_id: 1110,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://DFW Luxury Auto Rental-dev.1now.app",
  sender: "DFW Luxury Auto Rental",
  ccEmail: "DFW Luxury Auto Rental@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "We offer a curated fleet of premium luxury, exotic, and performance vehicles.",

  clientSays_arr: [
    {
      id: 1,
      title: "Audi RS e-tron GT Performance - December 2025",
      rating: 5,
      content:
        "I rented the 2026 Audi RS e-tron GT for a business conference in Dallas, and it was flawless. Smelled brand new :) Delivery to DFW airport was prompt, the car was pristine, and the electric performance turned heads. DFW Luxury Auto Rental made the process effortless—highly recommend for anyone seeking top-tier service!",
      client: "Alex R.",
    },
    {
      id: 2,
      title: "Porsche 911 Carrera - December 2025",
      rating: 5,
      content:
        "The 2022 Porsche 911 Carrera in Guards Red was a dream for our weekend getaway to Fort Worth Stockyards. Smooth handoff, impeccable condition, and the extended warranty gave us peace of mind. The team was responsive and professional— we'll be back for more luxury adventures in DFW!",
      client: "Sarah M.",
      city: "",
    },
    {
      id: 3,
      title: "December 2025 - Mercedes-Benz AMG G63 Night Black Magno",
      rating: 5,
      content:
        "Booked the AMG G63 in Night Black Magno for a Cowboys game tailgate against the Chargers. The SUV handled like a beast, and airport pickup was convenient. Beware - that blacked out look for a LOT of attention! It's an attention seeker. Minor delay on return, but support resolved it quickly with a credit. Solid option for event rentals in the metroplex. Will be back for another Luxury Car Rental during the 2026 FIFA World Cup in Dallas.",
      client: "Jordan K.",
      city: "",
    },
    {
      id: 4,
      title: "Mercedes-Benz AMG G63 Lunar Blue - December 2025",
      rating: 5,
      content:
        "As a first-time renter, I was impressed with the 2022 AMG G63 in Lunar Blue—elegant interior and powerful drive for exploring Dallas arts district. The platform's verification and insurance made me feel secure. Five stars for the personalized touch!",
      client: "Emily T.",
      city: "CHICAGO",
    },
    {
      id: 5,
      title: "January 2026 - Audi RS e-tron GT",
      rating: 5,
      content:
        "Rented for a conference— the Audi's red stitching interior was a hit. Picked up and dropped off in Arlington. Car was spotless (smelled and looked brand new), and the process via the app was seamless. DFW Luxury Auto Rental sets the bar high for peer-to-peer luxury.",
      client: "Mike S.",
      city: "",
    },
  ],

  //social links
  facebook: "https://www.facebook.com/profile.php?id=61587187676934",
  instagram: "https://www.instagram.com/dfwluxauto/",
  youtube: "https://www.youtube.com/channel/UCYiTrtX5gKzE9sOJ8WGErfA",
  x: "https://x.com/dfwluxauto",
  tiktok: "https://www.tiktok.com/@dfwluxauto",

  //contact
  address: "Arlington, Texas, USA",
  addressLink: "",
  phone: "407-799-1433", //pending
  email: "contact@dfwluxauto.com", //pending
  hours: "Mon - Sat: 9:00 AM - 9:00 PM\nSun: Closed",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
